import React, { FC } from "react";

import styles from "./styles.module.scss";

export interface DataSectionProps {}

export const DataSection: FC<DataSectionProps> = ({ children }) => {
  return <div className={styles.dataSection}>{children}</div>;
};
